import { REFUNDS_LIST_PATH } from 'shared/constants/routes';
import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
// Lazy-load the page entry, not the module index
var RedesignedRefundsList = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/RedesignedRefundsList');
});
// Mounts only the redesigned page; BaseRouting owns the flag switch.
export var Routing = function Routing() {
    return RouteGenerator({
        list: {
            path: REFUNDS_LIST_PATH,
            component: RedesignedRefundsList,
            exact: true
        }
    });
};
